"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPProfileId = exports.SIProfileId = void 0;
exports.SIProfileId = "71E5AA44-0C8C-4647-BDC4-996854A15FB9";
exports.IPProfileId = "7906B262-93DC-4666-A43A-14009374329E";
//# sourceMappingURL=types.js.map